



























































































































































































































































































































import store from '../store'
import { openLinkInBrowser } from '@/mla-shared'

export default {
  data () {
    return {
      title: 'Instructions'
    }
  },

  created: function () {
    store.state.activeTab = 'instructions'
  },

  methods: {
    openLink(url:string) {
      openLinkInBrowser(url);
    }
  },

  store
}
